// removed by extract-text-webpack-plugin
module.exports = {"container":"_1FteZ","owner-meta-container":"_1r-Cw","cover-image-container":"_1K6dD","progress-donate-container":"_2p9hq","owner":"_1K0Xr","crowdfunding-title-link":"_2d9Zt","title-wrapper":"_11AL7","title":"d6jEa","countdown":"_1d0Ds","meta":"n2OjD","progress":"_1_Jra","actions":"_3VWTR","share-unavailable":"_1h6Pv","recurring-donations":"_1Shug","bottom-right":"_1sHWO","link":"BTn-Q","body":"_3_0Xs","image":"_17et6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Reminders/DonationReminder.scss
// module id = ./src/components/Reminders/DonationReminder.scss
// module chunks = 5